import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  NavLink,
  Link
} from "react-router-dom";
import classNames from "classnames";

import { addListener, removeListener } from "../events";
import Login from "./Login/Login";
import Home from "./Home/Home";
import LBUs from "./LBUs/LBUs";
import Categories from "./Categories/Categories";
import Synonyms from "./Synonyms/Synonyms";
import BlockWords from "./BlockWords/BlockWords";
import CMS from "./CMS/CMS";
import ZeroHits from "./ZeroHits/ZeroHits";

import Header from "./Header/Header";
import LeftMenu from "./LeftMenu/LeftMenu";

import SnackBar from "./SnackBar/SnackBar";

import "./App.css";

class App extends Component {

  state = {
    leftMenuVisible: false,
    scrolled: false,
    numModalsOpen: 0,
    user: false
  };

  componentWillMount() {
    var user = JSON.parse(localStorage.getItem('user'));
    if (this.checkCred(user)) {
      console.log("we have a user")
      this.setState({ user: true })
    }
  }

  componentDidMount() {
    addListener("openmodal", this.onOpenModal);
    addListener("closemodal", this.onCloseModal);
    addListener("scroll_to_top", this.scrollToTop);
    addListener("snackbar", this.onSnackBar);
  }

  componentWillUnmount() {
    removeListener("openmodal", this.onOpenModal);
    removeListener("closemodal", this.onCloseModal);
    removeListener("scroll_to_top", this.scrollToTop);
    removeListener("snackbar", this.onSnackBar);
  }

  onSnackBar = message => {
    this.setState({ message });
  };

  onOpenModal = () => {
    this.setState(state => ({
      numModalsOpen: state.numModalsOpen + 1
    }));
  };

  onCloseModal = () => {
    this.setState(state => ({
      numModalsOpen: state.numModalsOpen - 1
    }));
  };

  onScroll = evt => {
    if (evt.target.scrollTop > 10) {
      if (!this.state.scrolled) {
        this.setState({ scrolled: true });
      }
    } else if (this.state.scrolled) {
      this.setState({ scrolled: false });
    }
  };

  scrollToTop = () => {
    this.content.scrollTop = 0;
  };

  logout = () => {
    localStorage.removeItem('user');
    this.setState({ user: false })
  }

  checkCred = user => {
    const cred = process.env.REACT_APP_USERNAME + ":" + process.env.REACT_APP_PASSWORD
    if (user === cred) return true
    return false
  }

  handleChange = user => {
    if (!this.checkCred(user)) {
      return alert('Wrong credentials')
    }
    localStorage.setItem('user', JSON.stringify(user));
    this.setState({ user: true })
  }

  render() {
    const { scrolled, numModalsOpen, message } = this.state;
    const modalVisible = numModalsOpen > 0;
    return (
      <Router>
        <div
          className={classNames("App", {
            scrolled,
            modalVisible
          })}
        >
          <Header onShowMenu={() => this.setState({ leftMenuVisible: true })} />
          <div className="wrap">
            <aside>
              <nav>
                <NavLink exact to="/" activeClassName="active">
                  Home
                </NavLink>
                <NavLink to="/lbus" activeClassName="active">
                  LBUs
                </NavLink>
                <NavLink to="/categories" activeClassName="active">
                  Categories
                </NavLink>
                <NavLink to="/synonyms" activeClassName="active">
                  Synonyms
                </NavLink>
                <NavLink to="/blockwords" activeClassName="active">
                  Block words
                </NavLink>
                <NavLink to="/cms" activeClassName="active">
                  CMS
                </NavLink>
                <NavLink to="/zero-hits" activeClassName="active">
                  Zero hits
                </NavLink>
                <Link onClick={this.logout} to="/">
                  Logout
                </Link>
              </nav>
            </aside>
            <section
              className="content"
              onScroll={this.onScroll}
              ref={elem => {
                this.content = elem;
              }}
            >
            {(!this.state.user) ? (
               <Login
                onChange={this.handleChange}
               />
            ) : (
              <div>
                <Route exact path="/" component={Home} />
                <Switch>
                  <Route
                    path="/lbus/add"
                    render={props => <LBUs {...props} add={true} />}
                  />
                  <Route path="/lbus/query/:query?" component={LBUs} />
                  <Route path="/lbus/:id?" component={LBUs} />
                  <Route
                    path="/categories/add"
                    render={props => <Categories {...props} add={true} />}
                  />
                  <Route path="/categories/:id?" component={Categories} />
                  <Route path="/synonyms" component={Synonyms} />
                  <Route path="/blockwords" component={BlockWords} />
                  <Route path="/cms" component={CMS} />
                  <Route path="/zero-hits" component={ZeroHits} />

                </Switch>
              </div>
            )}
            </section>
          </div>
          {this.state.leftMenuVisible && (
            <LeftMenu
              onClose={() => this.setState({ leftMenuVisible: false })} onChange={this.logout}
            />
          )}
          {message && (
            <SnackBar
              message={message}
              onClose={() => this.setState({ message: null })}
            />
          )}
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js